import { WifiOff } from "lucide-react";

export const UploadPausedBanner = ({ paused, testId = "upload-paused" }) => {
  if (!paused) return null;
  return (
    <div data-testid={testId} className="w-full flex flex-wrap items-center gap-x-3 gap-y-1.5 text-xs bg-amber-500/10 border border-amber-400/60 text-amber-700 rounded-xl px-3 py-2.5">
      <span className="flex items-center gap-1.5 font-semibold">
        <WifiOff className="w-3.5 h-3.5 shrink-0" />
        Upload onderbroken — {paused.done}/{paused.total} geüpload. Hervat automatisch zodra er verbinding is…
      </span>
      <span className="flex items-center gap-3 ml-auto">
        <button type="button" data-testid={`${testId}-resume`} onClick={paused.resumeNow}
          className="font-bold underline underline-offset-2 hover:opacity-70 transition-opacity duration-200">
          Nu hervatten
        </button>
        <button type="button" data-testid={`${testId}-cancel`} onClick={paused.cancel}
          className="font-bold text-red-600 hover:opacity-70 transition-opacity duration-200">
          Stoppen
        </button>
      </span>
    </div>
  );
};
